/* eslint-disable */
import React, { useEffect, useContext } from 'react';
import { Typography, Divider } from 'antd';
import { AuthContext, NavBarContext, AuthInfoContext } from '../App';

const { Title, Paragraph, Text } = Typography;

function PrivacyPolicy() {
  const { toggleNavBarVisibility, setSelectedKey } = useContext(NavBarContext);

  useEffect(() => {
    toggleNavBarVisibility(false);
    return () => {
      toggleNavBarVisibility(true);
    };
  }, []);

  return (
    <div style={{ width: '90%', textAlign: 'left' }}>
      <Title level={1} style={{ marginTop: '0em' }}>Privacy Policy</Title>
      <Text type="secondary">Last updated: {new Date().toLocaleDateString()}</Text>

      <Divider />

      <Title level={2}>1. Information We Collect</Title>
      <Paragraph>
        We collect information you provide directly to us, such as when you create an account, make a booking, or contact us for support. This may include:
      </Paragraph>
      <ul>
        <li>Personal identification information (name, passport details)</li>
        <li>Contact information (Telegram username, phone number)</li>
        <li>Travel preferences and booking history</li>
        <li>Payment information (processed securely through Stripe)</li>
      </ul>

      <Title level={2}>2. How We Use Your Information</Title>
      <Paragraph>
        We use the information we collect to:
      </Paragraph>
      <ul>
        <li>Process and fulfill your train bookings</li>
        <li>Communicate with you about your bookings and account</li>
        <li>Provide customer support</li>
        <li>Send you important service notifications</li>
        <li>Improve our services and user experience</li>
      </ul>

      <Title level={2}>3. Information Sharing</Title>
      <Paragraph>
        We may share your information with:
      </Paragraph>
      <ul>
        <li>KTMB (Malaysian railway operator) for ticket booking purposes</li>
        <li>Stripe for payment processing</li>
        <li>Service providers who assist us in operating our platform</li>
      </ul>
      <Paragraph>
        We do not sell, trade, or otherwise transfer your personal information to third parties for marketing purposes.
      </Paragraph>

      <Title level={2}>4. Data Security</Title>
      <Paragraph>
        We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.
      </Paragraph>

      <Title level={2}>5. Data Retention</Title>
      <Paragraph>
        We retain your personal information for as long as necessary to fulfill the purposes outlined in this privacy policy, unless a longer retention period is required or permitted by law.
      </Paragraph>

      <Title level={2}>6. Your Rights</Title>
      <Paragraph>
        You have the right to:
      </Paragraph>
      <ul>
        <li>Access your personal information</li>
        <li>Correct inaccurate information</li>
        <li>Request deletion of your information</li>
        <li>Withdraw consent for certain processing activities</li>
      </ul>

      <Title level={2}>7. Cookies and Tracking</Title>
      <Paragraph>
        We use cookies and similar tracking technologies to improve your experience on our platform. You can control cookie preferences through your browser settings.
      </Paragraph>

      <Title level={2}>8. Third-Party Services</Title>
      <Paragraph>
        Our service integrates with third-party services including Telegram and Stripe. These services have their own privacy policies that govern their use of your information.
      </Paragraph>

      <Title level={2}>9. Changes to This Policy</Title>
      <Paragraph>
        We may update this privacy policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the "Last updated" date.
      </Paragraph>

      <Title level={2}>10. Contact Us</Title>
      <Paragraph>
        If you have any questions about this privacy policy, please contact us at @SteadyShuttleSupport on Telegram.
      </Paragraph>

      <Divider />
      <Text type="secondary">
        By using SteadyShuttle, you acknowledge that you have read and understood this privacy policy.
      </Text>
    </div>
  );
}

export default PrivacyPolicy;